import * as yup from 'yup';

export const nafath_verification_schema = {
  number: '',
  crNumber: '',
  unifiedNo: '',
};

export const nafath_verification_validation_schema = yup.object().shape({
  number: yup
    .string()
    .required('number_required')
    .matches(/^[0-9]+$/, 'number_validation')
    .min(10, 'number_min_10_validation'),
});

export const wathq_verification_schema = {
  number: '',
  crNumber: '',
  unifiedNo: '',
};

export const wathq_verification_validation_schema = yup.object().shape({
  crNumber: yup.string(),
  unifiedNo: yup.string().min(10, 'number_min_10_validation'),
});
